(function ($) {
	class Block_End extends BD_Block {
		constructor() {
			super();

			this.type = "end";
			this.templateID = "end-template";

			this.elms = {
				showRating: ".js-show-rating",
				closeModal: '.modal__closeBtn',
				inputRating: 'input[type=radio][name=experience]',
				submitRating: '#submitExperienceButton',
				replayBtn: '#replayButton'
			};

			this._events = this.getEvents();

			/* custom attributes */
			this.audio = false;
		}

		getEvents() {
			const elms = this.elms;
			return [
				{
					event: "click",
					selector: elms.replayBtn,
					handler: this.onReplay,
				},
				{
					event: "click",
					selector: elms.showRating,
					handler: this.onShowRating,
				},
				{
					event: "click",
					selector: elms.closeModal,
					handler: this.onCloseModal,
				},
				{
					event: "click",
					selector: elms.inputRating,
					handler: this.onSelectRating,
				},
				{
					event: "click",
					selector: elms.submitRating,
					handler: this.onSubmitRating,
				},
			];
		}

		beforeinit() {
			this.render();
			this.setGameState();
		}

		render() {
			const htmlTemplate = $("#" + this.templateID).html();
			let template = Handlebars.compile(htmlTemplate);

			const html = template(this._data);
			$("#templateWrapper").html(html);
			$(".gameScreen")
				.removeClass("is-active")
				.filter("#endScreen")
				.addClass("is-active");
		}

		setGameState() { }

		/* ========= ELEMENT FUNCTION HANDLER ===============*/

		onReplay(e, $el) {
			$el.attr('disabled', true);

			bdapi.post('member/reset-active-game-progress', {}).then((res) => {
				const resData = res.data;
				const data = resData.data;
				window.location.reload();
			}).catch((err) => {
				console.log('err', err)
				$el.removeAttr('disabled');
			});
		}

		onShowRating() {
			$('#page').addClass('is-modal');
		}

		onCloseModal() {
			$('#page').removeClass('is-modal');
		}

		onSelectRating() {
			$('#submitExperienceButton').prop('disabled', false)
		}

		onSubmitRating(e, $el) {
			$el.prop('disabled', true)
			const ratingValue = $(this.elms.inputRating.concat(':checked')).val();

			bdapi.post('game/submit-rating', { rating_value: ratingValue })
				.then((response) => {
					const status = response.status;
					$('#page').removeClass('is-modal')
					if (status !== 200) { return; }
				}).catch((error) => { });
		}
	}

	return new Block_End();
})(jQuery);
